export default {
    //首页弹窗管理
    getListByPage: '/system/home/popup/getListByPage', //分页首页弹窗列表接口
    show: '/app/home/popup/show', //APP终端查询弹窗接口
    update: '/system/home/popup/update', //修改首页弹窗接口
    stop: '/system/home/popup/stop', //停止首页弹窗接口
    delete: '/system/home/popup/delete', //删除首页弹窗接口
    release: '/system/home/popup/release', //发布首页弹窗接口
    add: '/system/home/popup/add', //新增首页弹窗接口
    getDetailInfo: '/system/home/popup/getDetailInfo', //查询弹窗详情信息
    stick: '/system/home/popup/stick', //首页弹窗管理-弹窗置顶
    popupAddLog:'/system/home/popup/log/add',//弹窗操作说明添加接口
    getListByPageOfLog:'/system/home/popup/log/getListByPage',//首页弹窗操作记录列表接口
}